export const EOperatingSystem = {
  macOS: 'macOS',
  windows: 'Windows',
  linux: 'Linux',
  unknown: 'Unknown',
} as const

export type EOperatingSystem = (typeof EOperatingSystem)[keyof typeof EOperatingSystem]

export function getOS(): EOperatingSystem {
  const platform = navigator.platform?.toLowerCase() || navigator.userAgent?.toLowerCase()
  if (platform.indexOf('mac') !== -1) {
    return EOperatingSystem.macOS
  } else if (platform.indexOf('win') !== -1) {
    return EOperatingSystem.windows
  } else if (platform?.indexOf('linux') !== -1) {
    return EOperatingSystem.linux
  } else {
    return EOperatingSystem.unknown
  }
}
